import React, { createContext, useContext } from 'react';
import * as api from '../api/inventory';

const InventoryContext = createContext();

export function InventoryProvider({ children }) {
  return (
    <InventoryContext.Provider
      value={{
        listItems: api.listItems,
        getItem: api.getItem,
        createItem: api.createItem,
        updateItem: api.updateItem,
        deleteItem: api.deleteItem
      }}
    >
      {children}
    </InventoryContext.Provider>
  );
}

export function useInventory() {
  return useContext(InventoryContext);
}
